import React from 'react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden" data-id="element-71">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-72">
        <img src="https://cdn.magicpatterns.com/uploads/5rEJqRmoHK46hcA51EMKZU/Concepto_aereo.jpg" alt="Avión de carga" className="w-full h-full object-cover" data-id="element-73" />
        <div className="absolute inset-0 bg-[#1B2B5E]/70 mix-blend-multiply" data-id="element-74"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#1B2B5E] via-transparent to-transparent" data-id="element-75"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-76">
        <div className="max-w-3xl" data-id="element-77">
          <div className="flex items-center gap-3 mb-6" data-id="element-78">
            <span className="text-3xl" role="img" aria-label="USA Flag" data-id="element-79">
              🇺🇸
            </span>
            <div className="h-0.5 w-12 bg-[#F5A623]" data-id="element-80"></div>
            <span className="text-3xl" role="img" aria-label="Venezuela Flag" data-id="element-81">
              🇻🇪
            </span>
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6" data-id="element-82">
            Tu carga en buenas manos, de Miami a Venezuela
          </h1>

          <p className="text-lg md:text-xl text-gray-200 mb-10 max-w-2xl leading-relaxed" data-id="element-83">
            Envíos aéreos y marítimos confiables desde Estados Unidos hacia
            Venezuela, sede en Miami. Rápidos, seguros y con atención
            personalizada.
          </p>

          <div className="flex flex-col sm:flex-row gap-4" data-id="element-84">
            <a href="https://wa.link/o50a7n" target="_blank" rel="noopener noreferrer" className="bg-[#F5A623] text-[#1B2B5E] px-8 py-4 rounded-lg font-bold text-lg text-center hover:bg-white transition-colors shadow-lg" data-id="element-85">
              Cotiza tu envío
            </a>
            <a href="#como-funciona" className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-bold text-lg text-center hover:bg-white hover:text-[#1B2B5E] transition-colors" data-id="element-86">
              ¿Cómo funciona?
            </a>
          </div>
        </div>
      </div>
    </section>;
}